import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { populateItemsByIdsArray } from '../../helpers'
import { renderArrayObjectValueWithComas } from '../../../../../Facebook/LineItemForms/LineItemFacebookEdit/Sections/CustomAudiencesSection/helpers'

import { lineItemSelector } from '../../../../../../modules/selectors/lineItems'
import {
  getAdditionalInterestCategoriesByIdsSelector,
  getPurchaseIntentionCategoriesByIdsSelector,
  tikTokInterestsSelector
} from '../../../../../../modules/selectors/tikTokConstants'
import { INTEREST_KEYWORD_IDS } from '../../../../UploadTikTokAdCreative/UploadTikTokAdCreativeForm/LineItemForm/Steps/CustomAudiencesStep/TikTokUploadCreativeAudienceFields/TikTokAdvancedAudienceTargetingSection/AdditionalInterestCategoriesMultiselect'
import { PURCHASE_INTENTION_KEYWORD_IDS } from '../../../../UploadTikTokAdCreative/UploadTikTokAdCreativeForm/LineItemForm/Steps/CustomAudiencesStep/TikTokUploadCreativeAudienceFields/TikTokAdvancedAudienceTargetingSection/PurchaseIntentionCategoriesMultiselect'

const AudienceSectionPreview = () => {
  const lineItem = useSelector(lineItemSelector)
  const { interest_category: interestIds } = useSelector(lineItemSelector)
  const tikTokInterests = useSelector(tikTokInterestsSelector)
  const additionalInterestCategoriesByIds = useSelector(getAdditionalInterestCategoriesByIdsSelector)
  const purchaseIntentionCategoriesByIds = useSelector(getPurchaseIntentionCategoriesByIdsSelector)

  const anyItemsExist = interestIds?.length

  const additionalInterestCategoriesIds = lineItem[INTEREST_KEYWORD_IDS]
  const purchaseIntentionCategoriesIds = lineItem[PURCHASE_INTENTION_KEYWORD_IDS]

  const populatedInterests = useMemo(
    () =>
      populateItemsByIdsArray({
        idsArray: interestIds,
        itemsList: tikTokInterests,
        itemIdFieldName: 'id',
        itemFallbackNameString: 'Interest'
      }),
    [interestIds, tikTokInterests]
  )

  if (!anyItemsExist && !additionalInterestCategoriesIds?.length && !purchaseIntentionCategoriesIds?.length) {
    return null
  }

  return (
    <>
      {!!populatedInterests?.length && <p>Interests: {renderArrayObjectValueWithComas(populatedInterests, 'name')}</p>}
      {additionalInterestCategoriesIds?.length > 0 && (
        <p>
          Additional Interests:{' '}
          {additionalInterestCategoriesByIds.map(additionalInterest => additionalInterest.keyword).join(', ')}
        </p>
      )}
      {purchaseIntentionCategoriesByIds?.length > 0 && (
        <p>
          Purchase Intention Categories:{' '}
          {purchaseIntentionCategoriesByIds
            .map(purchaseIntentionCategory => purchaseIntentionCategory.keyword)
            .join(', ')}
        </p>
      )}
    </>
  )
}

export default AudienceSectionPreview
